import React from "react";
import { useLang } from "../contexts/LanguageContext";
import { useSearchParams } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { BackBar } from "../components/BackBar";
import { MSFormEmbed } from "../components/MSFormEmbed";

const FORM_URL = process.env.REACT_APP_MS_FORM_INQUIRY_URL || "";
const CONTACT_EMAIL = "info@ofalycee.fr";

export default function InquiryPage() {
  const { t, lang } = useLang();
  const [searchParams] = useSearchParams();
  const prefillTrack = searchParams.get("track") || "";
  const prefillProgram = searchParams.get("program") || "";
  const prefillBand = searchParams.get("grade_band") || "";

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-12 py-8" data-testid="inquiry-page">
      <BackBar to="/" fallbackLabelFr="Accueil" fallbackLabelEn="Home" />
      <p className="overline mb-3">OFA France</p>
      <h1 className="font-display font-bold text-4xl lg:text-5xl tracking-tighter mb-3">{t("inquiry.title")}</h1>
      <p className="text-muted-foreground mb-4">{t("inquiry.subtitle")}</p>

      <div className="mb-8 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-card text-sm">
        <span className="text-muted-foreground">
          {lang === "fr" ? "Préférez écrire ?" : "Prefer to email us?"}
        </span>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="inquiry-email-link"
          className="text-primary font-semibold hover:underline"
        >
          {CONTACT_EMAIL}
        </a>
      </div>

      {(prefillTrack || prefillProgram) && (
        <div data-testid="prefill-banner" className="mb-8 flex items-start gap-3 p-4 rounded-xl border-2 border-primary/30 bg-primary/5">
          <Sparkles className="w-5 h-5 text-primary shrink-0 mt-0.5" />
          <div className="text-sm">
            <div className="font-semibold text-primary">
              {lang === "fr" ? "Recommandation issue du Pathway Recommender" : "Recommendation from the Pathway Recommender"}
            </div>
            <div className="text-muted-foreground mt-0.5">
              {prefillTrack && <>Track : <b>{prefillTrack === "fluent" ? "Fluent Track" : "Bridge Track"}</b></>}
              {prefillTrack && prefillProgram && " · "}
              {prefillProgram && <>{lang === "fr" ? "Programme" : "Program"} : <b>{t(`programs.${prefillProgram}`)}</b></>}
              {prefillBand && <> · {lang === "fr" ? "Niveau" : "Level"} : <b>{
                prefillBand === "elementary" ? (lang === "fr" ? "GS – CM2" : "K – Grade 5")
                : prefillBand === "middle" ? (lang === "fr" ? "6e – 3e" : "Grades 6 – 9")
                : prefillBand === "high" ? (lang === "fr" ? "2nde – Terminale" : "Grades 10 – 12")
                : prefillBand
              }</b></>}
            </div>
            <p className="text-muted-foreground/80 text-xs mt-2">
              {lang === "fr"
                ? "Merci d'indiquer ces informations dans la zone « Programme souhaité / commentaires » du formulaire ci-dessous."
                : "Please mention this in the \"Program of interest / comments\" section of the form below."}
            </p>
          </div>
        </div>
      )}

      <MSFormEmbed
        url={FORM_URL}
        title={lang === "fr" ? "Demande d'informations OFA France" : "OFA France information request"}
        lang={lang}
        testId="inquiry-form-embed"
        height={1100}
      />
    </div>
  );
}
